import stl from "./CarsFinance.module.css";
import {CDN_LINK} from "@globalConfig";
import {useTranslation} from "@i18n";
import useHelpers from "@hooks/useHelpers";

const CarsFinance = ({  cityName }) => {
  const {t} = useTranslation();
  const {createUrl} = useHelpers();
  return (
    <>
      <div className={stl.CCF_container}>
        <div className={stl.CCF_content}>
          <h2>
            {t("تمويل السيارات وتقسيطها في {{cityName}}", {
              ns: "web_city",
              cityName
            })}
          </h2>
          <p>
            {t(
              "اشتري سيارتك بأقساط ميسرة في مدينة {{cityName}} بكل سهولة من خلال نظام التمويل الميسر لكافة موديلات السيارات المستعملة والجديدة",
              { ns: "web_city", cityName: cityName }
            )}
          </p>
          <a
            className={["redBtn", stl.button].join(" ")}
            href={createUrl("/financing")}
          >
            {t("سيارات بالأقساط في {{cityName}}", {
              ns: "web_city",
              cityName
            })}
          </a>
        </div>
        <img
          src={CDN_LINK+"/assets/images/city/finance_cars.webp"}
          alt="cars finance image"
          width={200}
          height={164}
          loading="lazy"
        />
      </div>
    </>
  );
};

export default CarsFinance;
